import { defineAction, enumerated, expression } from '~/prix'
import { z } from 'zod'
import protocolListAction from './protocolList.action.json' with { type: 'json' }

import { protocolObject } from '../protocolObject'
export const protocolExpression = expression(protocolObject.shape)

const protocolListDefinition = defineAction({
  ...protocolListAction,

  input: z.object({
    filter: protocolExpression.nullish(),
    limit: z.number().min(1).max(15000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      synchronizedAt: 'Data de sincronização',
      id: 'Identificador',
      code: 'Código',
      fullName: 'Nome completo',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(protocolObject),
    count: z.number(),
  }),
})

export default protocolListDefinition
